// @flow

// DebugPinImpressions shows a colored box over the pins that have been
// impressed when debugging is enabled.

import React from 'react';
import urlUtil from 'app/common/lib/urlUtil';
import { Box, Text } from 'gestalt';

const URL_QUERY_PARAM = 'debug_impression_log';

const styles = {
  impressed: { backgroundColor: '#adebad', opacity: 0.5 },
};

export type DebugImpressionState = 'paused' | 'started';

export type Props = {
  debugImpressionState: DebugImpressionState,
  slotIndex: number,
};

export const debugPinImpressionsEnabled = () =>
  urlUtil.getQueryStringParams()[URL_QUERY_PARAM] !== undefined;

export default function DebugPinImpressions({ debugImpressionState = 'paused', slotIndex }: Props) {
  if (debugImpressionState === 'paused') {
    return null;
  }

  return (
    <Box
      dangerouslySetInlineStyle={{ __style: styles.impressed }}
      data-test-id="debug-pin-impressions"
      position="absolute"
      top
      left
      right
      bottom
    >
      <Box position="absolute" top left padding={2} color="darkGray">
        <Text size="xl" color="white">
          {slotIndex}
        </Text>
      </Box>
    </Box>
  );
}
